import React, { useEffect } from 'react';
import { GridTable, GridController } from '@ctsu/ctsu-mui-grid';
import { compose, withHandlers, withState } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import _ from 'lodash';
import { openConfirmation } from 'helpers/Confirmation';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum , TE } from 'appconstants';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { CanUserDelPSRAffiliations } from 'appconstants/Permission';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import PropTypes from 'prop-types';
import { FasHistory } from 'assets/icons';
import EditSpecialRequirement from './EditSpecialRequirement';
import { SplReqColumns } from '../gridcolumns';

const verifiedByFields = [
  'MANUAL',
  'PERSON_ATTRIBUTE',
  'INTERNATIONAL',
  'INSTITUTION_ATTRIBUTE'
];

let setEditingFlag;

const controller = GridController.createController();
const SpecialReq = props => {
  const {
    state,
    setState,
    psrSplReqAffi,
    psrData,
    psrId,
    savePSRAffiliationInfo,
    editMode,
    deleteAffiliation,
    editAffiliation,
    disabled,
    isNewpsr,
    disableCreate,
    tagId,
    handleHistClick
  } = props;
  useEffect(() => {
    setState({});
  }, [psrId, setState]);

  let verified = null;
  if (!_.isEmpty(psrData)) {
    verified = psrData.verifiedBy;
  }

  function IsRowEditable(verifiedVal) {
    return verifiedByFields.includes(verifiedVal);
  }

  function checkDisabled() {
    if (editAffiliation) {
      return (editAffiliation && disabled)
    }
    return !disabled;
  }

  const saveSplReq = () => {
    if (_.isEmpty(state)) {
      openConfirmation({
        title: 'Validation Error',
        message: 'please select input field(s)',
        onAction: () => false,
        name: 'spl_req'
      });
    } else if (verified === 'INTERNATIONAL') {
        if(state.countryCode || state.siteCtepId) {
          savePSRAffiliationInfo({
            ...state,
            psrId
          });
        } else {
          openConfirmation({
            title: 'Validation Error',
            message: 'To perform the operation either Country or CTEP ID information is mandatory.',
            onAction: () => false,
            name: 'spl_req'
          });
        }
    } else {
      savePSRAffiliationInfo({
        ...state,
        psrId
      });
    }
  };


  const RenderEditRow = (row, setEditing, renderScenario) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }
    setEditingFlag = (flg) => {
      setEditing(flg);
      setState({});
    };

    if (isNewpsr) {
      const ele = document.querySelectorAll('[data-id="PROTOCOL_newPsraffiandverifications_table-grid-close-button"]')[0];
      if (ele) {
        ele.onclick = (eve) => {
          disableCreate(false);
          return false;
        };
      }
    }


    return (
      <EditSpecialRequirement
        state={state || row}
        save={saveSplReq}
        setEditing={setEditing}
        disableCreate={disableCreate}
        isNewpsr={isNewpsr}
        defaultRow={row}
        setState={setState}
        verifiedBy={verified}
        editAffiliation
      />
    );
  }

  const onDelete = (row) => {
    const confirmDelete = () => {
      deleteAffiliation(row.affilId, psrId);
    }
    openConfirmation({
      message: `Do you want to delete PSR Affiliation?`,
      onAction: confirmDelete,
      name: 'delete_affil'
    });
    
  };

  const customHeaderIcons = () => {
    return (
      <button
        type="button"
        data-id="viewAffiliationsHistoryAction"
        onClick={() => {
          handleHistClick();
        }}
        aria-label="View the change history for affiliations and verifications"
        className="fn-btn turquoise mr-0"
        title="View the change history for affiliations and verifications"
      >
        <FasHistory />
      </button>
    );
  }

  return (
    <ValidatorForm>
      <GridTable
        tag={`${TE.ID}${tagId}${TE.TABLE}`}
        title="Affiliations & Verifications"
        exportTitle={`Affiliations & Verifications-${useGetPathProtocol()}-PSR`}
        user={GetUserFullName()}
        columns={SplReqColumns}
        rows={psrSplReqAffi}
        editMode={editMode && IsRowEditable(verified)}
        editable
        controller={controller}
        deletable={CanUserDelPSRAffiliations()}
        filterable
        disableEditIcon = {checkDisabled()}
        disableOnRowClicked = {checkDisabled()}
        sortable
        enableToolbar
        onDelete={onDelete}
        renderCustomHeaderIcons={customHeaderIcons}
        renderEditRow={RenderEditRow}
        rowEditable={() => IsRowEditable(verified)}
        rowDeletable={() => true}
        allowAddRow={IsRowEditable(verified)}
        toPdf={false}
      />
    </ValidatorForm>
  );
};

const SpecialRequirement = compose(
  withAppContext,
  withState('state', 'setState', {}),
  withHandlers({
    updatePsrData: props => payload => {
      const {
        setPsrData,
        psrData,
        disableCreate
      } = props;
      disableCreate(false);
      const affils = psrData.affiliations || [];
      if (payload.index) {
        const index = _.findIndex(affils, affil => affil.index === payload.index )
        affils[index] = {...payload};
      } else {
        const indexObj = {
          index: affils.length+ 1
        };
        affils.push(_.assign(payload, indexObj));
      }
      setPsrData({
        ...psrData,
        affiliations: affils
      });
      setEditingFlag(false);
      controller.reload();
    }
  }),
  withHandlers({
    savePSRAffiliationInfo: props => (postBody, flagFun) => {
      const {
        onSave,
        context,
        psrId,
        editAffiliation,
        updatePsrData
      } = props;
      if (!editAffiliation) {
        const confirmSave = () => {
          const payload = _.omit(postBody, ['name']);
          onSave(payload, psrId).subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              openSnackbar({
                message: GetFromCtxValue(context, 'PROTOCOL_PSR_SPR_SUCCESS'),
                variant: 'success',
                name: 'psr_spr'
              });
              setEditingFlag(false);
            }
          });
        };
        openConfirmation({
          message: GetFromCtxValue(context, 'PROTOCOL_PSR_SPR_CONFIRM'),
          onAction: confirmSave,
          name: 'psr_spr'
        });
      } else {
        const payload = _.omit(postBody, ['name', 'psrId']);
        updatePsrData(payload, flagFun);
      }
    }
  })
)(SpecialReq);

SpecialRequirement.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]),
  psrData: PropTypes.oneOfType([PropTypes.object]),
  psrId: PropTypes.number,
  onSave: PropTypes.func.isRequired
};

SpecialRequirement.defaultProps = {
  psrId: null,
  data: [],
  psrData: null
};

export { SpecialRequirement };
